import React, { useState } from 'react';
const ProfileAvatar = ({ name = '', src, className = '' }) => {
  const [failed, setFailed] = useState(false);
  return (
    <div className={`profile-avatar ${className}`}>
      {src && !failed ? (
        <img src={src} alt={name} onError={() => setFailed(true)} />
      ) : (
        <span aria-label={name}>
          {name
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map((part) => part[0])
            .join('')
            .toUpperCase() || 'Rx'}
        </span>
      )}
    </div>
  );
};
export default ProfileAvatar;
